import gql from "graphql-tag";
export default gql`
  mutation($orderId: ID!, $customerInfo: CustomerInfo!) {
    updateCustomerInfo(orderId: $orderId, customerInfo: $customerInfo)
  }
`;
